export const HouseMapCursor: React.FC<{ className?: string }> = ({ className }) => {
  return (
    <g id="locationCursor" style={{ display: 'none' }} className={className}>
      <path
        d="M22.6873 47.4419C22.303 47.821 21.697 47.8209 21.3124 47.4421C15.8988 42.1103 4 29.3161 4 18.4226C4 13.5668 5.89642 8.90981 9.27208 5.47622C12.6477 2.04262 17.2261 0.113647 22 0.113647C26.7739 0.113647 31.3523 2.04262 34.7279 5.47622C38.1036 8.90981 40 13.5668 40 18.4226C40 29.2287 28.1008 42.1032 22.6873 47.4419Z"
        fill="#E63312"
      />
      <path
        d="M22 25.6191C20.5166 25.6191 19.0666 25.1793 17.8332 24.3552C16.5999 23.5311 15.6386 22.3597 15.0709 20.9893C14.5032 19.6188 14.3547 18.1108 14.6441 16.656C14.9335 15.2011 15.6478 13.8647 16.6967 12.8158C17.7456 11.7669 19.082 11.0526 20.5368 10.7633C21.9917 10.4739 23.4997 10.6224 24.8701 11.19C26.2406 11.7577 27.4119 12.719 28.236 13.9524C29.0601 15.1857 29.5 16.6358 29.5 18.1191C29.5 20.1083 28.7098 22.0159 27.3033 23.4224C25.8968 24.829 23.9891 25.6191 22 25.6191Z"
        fill="white"
      />
    </g>
  );
};
